var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphFatigue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 85,
    viewBox: "0 0 80 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.664 15.947-11.443 31.44a1.9 1.9 0 0 1-2.435 1.135l-17.712-6.447a1.9 1.9 0 0 1-.587-3.228l29.155-24.992a1.9 1.9 0 0 1 3.022 2.092z",
    fill: "#92A0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.336 69.053 11.443-31.44a1.9 1.9 0 0 1 2.435-1.135l17.712 6.447a1.9 1.9 0 0 1 .587 3.228L33.358 71.145a1.9 1.9 0 0 1-3.022-2.092z",
    fill: "#606A96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphFatigue);
export default __webpack_public_path__ + "static/media/icons_graph_fatigue.d8911f529963b3e06ba5b9fd3bba1544.svg";
export { ForwardRef as ReactComponent };